import ShellAuthContext from './AuthContext.js';

/**
 * Mounted by the Core Shell to broadcast its auth state to embedded child apps.
 * Child apps read from ShellAuthContext instead of calling useAuth0() directly.
 *
 * @param {object} props
 * @param {string|null} props.token   - Access token obtained by the Shell
 * @param {object|null} props.user    - Auth0 user profile
 * @param {boolean}     props.isAuthenticated
 * @param {Function}    props.getAccessTokenSilently - Auth0 silent token getter for refresh
 * @param {React.ReactNode} props.children
 */
const ShellAuthProvider = ({ token, user, isAuthenticated, getAccessTokenSilently, children }) => {
  return (
    <ShellAuthContext.Provider value={{ token, user, isAuthenticated, getAccessTokenSilently }}>
      {children}
    </ShellAuthContext.Provider>
  );
};

export default ShellAuthProvider;
